const prod = {
    BASE_URL: 'https://schoolmanager1.herokuapp.com/api/la'
};

const dev = {
    BASE_URL: 'http://localhost:5001/api/la'
};

export const config = process.env.NODE_ENV === 'development' ? dev : prod;